import React from "react";
import { twMerge } from "tailwind-merge";

const AvatarInitials = ({ firstName, lastName, className, onClick }) => {
  const initials = `${firstName?.[0] || ""}${
    lastName?.[0] || ""
  }`.toUpperCase();

  return (
    <div
      className={twMerge(
        "flex items-center tracking-wide justify-center w-12 h-12 rounded-full bg-primary text-xl text-white font-normal",
        className
      )}
      onClick={onClick}
    >
      {initials}
    </div>
  );
};

export default AvatarInitials;
